import { action } from 'typesafe-actions';
import { FormValues } from '../models/FormValues';
import {
    STORE_FORM_VALUES,
    CLEAR_FORM_VALUES,
    ERROR_FORM_GETAPI,
    CLEAR_ERROR_FORM_GETAPI,
    ERROR_FORM_MESSAGE,
    CLEAR_ERROR_FORM_MESSAGE
} from '../constants/Constants';
import fetch from 'cross-fetch';
import { ErrorMessageService } from '../services/ErrorMessageService';
import { ESBOnlineService } from '../services/ESBOnlineService';
import { AnimationService } from '../services/AnimationService';
import { FormService } from '../services/FormService';
import { reformatUrlRelativePaths } from '@fnv-core/utils';

export const showErrorOnApiError = (error = null) => action(ERROR_FORM_GETAPI, error);
export const clearErrorOnApiError = () => action(CLEAR_ERROR_FORM_GETAPI, {});

export const storeFormValues = (formName: string, values: any) =>
    action(STORE_FORM_VALUES, { formName: formName, values: values } as FormValues);
export const clearFormValues = (formName: string) =>
    action(CLEAR_FORM_VALUES, { formName: formName } as FormValues);

export const storeFormErrorMessage = (formName: string, errorMessage: string) =>
    action(ERROR_FORM_MESSAGE, { formName: formName, errorMessage: errorMessage });

export const clearFormErrorMessage = (formName: string) =>
    action(CLEAR_ERROR_FORM_MESSAGE, { formName: formName });

export const fillFormViaApi = (formName: string, url : string, formDefinitions: any[], formSteps: string[], formConfig?: any) => 
  dispatch => {
    url = reformatUrlRelativePaths(url);
    return fetch(url)
        .then(response => {

            AnimationService.finishPreloadForm(formName);

            if (response.status >= 300) {
                dispatch(storeFormValues(formName, {}));
                dispatch(showErrorOnApiError());
                ESBOnlineService.setESBIsOnline(false);
                dispatch(
                    storeFormErrorMessage(
                        formName,
                        ErrorMessageService.errorMessageNotAllDataCanBeRetrieved()
                    )
                );
                
                AnimationService.triggerAnimations();
                return { _error: true };
            } else {
                
                ESBOnlineService.setESBIsOnline(true);                
                return response.json();
            }
        })
        .then(json => {
            if (!json._error) {
                dispatch(clearFormErrorMessage(formName));

                // prefilled data is put in each form step
                // but is removed when writing the formstep on submit of each step
                // AjaxCallHelper/FormikHelper and RichtTextContent are aware of that
                
                dispatch(storeFormValues(formName, json));
                formSteps.map((stepFormName) => {
                    if (stepFormName != formName) {
                        dispatch(storeFormValues(stepFormName, json));
                    }
                });
                AnimationService.triggerAnimations();

                if (formConfig && !!formConfig.fillMemberNameAsSubtitle) {                    
                    if (json.Naam && json.IsLid) {
                        FormService.setIsInLidZoekenSubFunctions(true);
                        FormService.setLidZoekenSubFunctionsForMember({
                            memberName: json.Naam,
                            isMember: json.IsLid
                        });
                    } else {
                        FormService.setIsInLidZoekenSubFunctions(false);
                        FormService.setLidZoekenSubFunctionsForMember({});
                    }
                }

                return true;
            }
        })
        .catch(err => {            
            // tslint:disable-next-line
            console.error(err);
            AnimationService.finishPreloadForm(formName);
            ESBOnlineService.setESBIsOnline(true);
            dispatch(showErrorOnApiError());
            AnimationService.triggerAnimations();
        });
};
